import { parseView } from '#lib/view';
import { CogniteAssetModel } from '#schema/model/cdm/CogniteAssetModel';
import { CogniteFileModel } from '#schema/model/cdm/CogniteFileModel';
import { CogniteTimeSeriesModel } from '#schema/model/cdm/CogniteTimeSeriesModel';

// TODO: DM/views in tree structure

export const DataModel = {
  CogniteCore: {
    externalId: 'CogniteCore',
    space: 'cdf_cdm',
  },
  CogniteProcessIndustries: {
    externalId: 'CogniteProcessIndustries',
    space: 'cdf_idm',
  },
} as const;

// biome-ignore lint/suspicious/noEmptyInterface: Overrides in root project
export interface DataModel {}

// Cognite CDM/IDM views
export const CogniteAssetView = parseView({
  view: { externalId: 'CogniteAsset' },
  model: CogniteAssetModel,
  dataModel: DataModel.CogniteCore,
});
export const CogniteFileView = parseView({
  view: { externalId: 'CogniteFile' },
  dataModel: DataModel.CogniteCore,
  model: CogniteFileModel,
});
export const CogniteTimeSeriesView = parseView({
  view: { externalId: 'CogniteTimeSeries' },
  dataModel: DataModel.CogniteCore,
  model: CogniteTimeSeriesModel,
});
